// 引入 Vue  
import Vue from 'vue';
// 引入 Vue Router  
import VueRouter from 'vue-router';
import routes from '@/config/AppRoutes'


// 创建并导出路由实例  
const router = new VueRouter({
	mode: 'history', // 或者 'hash'  
	routes,
	base: "/yunxuexipingtai",
});

// 导出路由实例  
export default router;